import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Configurar retry automático para TODAS as chamadas axios
import './utils/axiosSetup';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
